module.exports = __webpack_public_path__ + "static/media/faccia_06.046808f6.png";